import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AuthGuard } from '@next/core-lib/authorization';

import { VarietyPropertiesComponent } from './variety-properties.component';

@NgModule({
  declarations: [],
  imports: [
    RouterModule.forChild([
      {
        path: 'variety-properties',
        component: VarietyPropertiesComponent,
        canActivate: [AuthGuard],
      },
    ]),
  ],
})
export class VarietyPropertiesRoutingModule {}
